module.exports = __webpack_public_path__ + "img/i_leave.cc9dd992.svg";